<template>
  <v-data-table
    :headers="headers"
    :items="orders"
    :loading="loading"
    class="elevation-1"
  >
    <template v-slot:[`item.rule`]="{ item }">
      <TradeRulePreview :rule="item.rule" />
    </template>

    <template v-slot:[`item.tradeStock`]="{ item }">
      {{ item.tradeStock?.name || 'N/A' }}
    </template>


    <template v-slot:[`item.history`]="{ item }">
      <v-btn icon @click="$emit('show-history', item)">
        <font-awesome-icon :icon="['fas', 'clock-rotate-left']" />
      </v-btn>
    </template>


  </v-data-table>
</template>

<script setup>
import TradeRulePreview from './TradeRulePreview.vue'

defineProps({
  orders: Array,
  loading: Boolean
})

const headers = [
  { title: 'ID', key: 'trade_order_id' },
  { title: 'Stock', key: 'tradeStock' },
  { title: 'Qty', key: 'qty' },
  { title: 'Rule', key: 'rule' },
  { title: 'Status', key: 'status' },
  { title: 'History', key: 'history', sortable: false }
]
</script>